import React, { createContext, useContext, useState } from 'react';

type Ctx = { editMode: boolean; setEditMode: (v: boolean) => void };
const EditModeContext = createContext<Ctx | undefined>(undefined);

export const EditModeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [editMode, setEditMode] = useState(false);
  return <EditModeContext.Provider value={{ editMode, setEditMode }}>{children}</EditModeContext.Provider>;
};

export const useEditMode = () => {
  const ctx = useContext(EditModeContext);
  if (!ctx) throw new Error('useEditMode must be used within EditModeProvider');
  return ctx;
};
